import request from '@/utils/req.js';

//新增方案   药物治疗  药品查询
export function api_getdrug(params) {
    return request.post("/admin/drug-new/page",params);
}

//功能训练
export function api_get_train_chapter(params) {
    return request.get("/admin/train-chapter/",params);
}

//功能训练 培训教程查询
export function api_get_train_course(params) {
    return request.get("/admin/train-course",params);
}

//获取运动分类
export function api_standard_list(params) {
    return request.post("/admin/standard-category/list",params);
}

//根据运动分类获取项目
export function api_movement_info_list(params) {
    return request.post("/admin/movement-info/list",params);
}

// 逻辑树编链类根据类名和名称搜索方案
export function getSchemeItemBySchemeTypeAndName(params) {
    return request.post("/admin/scheme-item/getSchemeItemBySchemeTypeAndName", params);
}

// 逻辑链关联的项目模板添加
export function createSchemeItemTemplate(params) {
    return request.post("/admin/decision-scheme-item-template", params);
}

// 逻辑链关联的项目模板列表
export function getSchemeItemTemplateList(params) {
    return request.post("/admin/decision-scheme-item-template/list", params)
}

// 获取单个模板详情
export function getTemplateDetail(id) {
    return request.get(`/admin/decision-scheme-item-template/${id}`);
}

// 编辑更新模板
export function updateSchemeItemTemplate(params) {
    return request.put("/admin/decision-scheme-item-template", params);
}

// 删除模板
export function getTemplateDelete(id) {
    return request.delete(`/admin/decision-scheme-item-template/${id}`);
}



